import { getSeatId } from './seatIdUtils';
const TRAVELER_BUTTON_ID = id => `#seatMapTravelerButton-${id}`;
const TRAVELER_LIST_BUTTON_ID = id => `#seatMapTravelerListButton-${id}`;
const SAVE_AND_CONTINUE_BUTTON_ID = '#saveAndContinue-button';
const CABIN_LAYOUT_SELECTOR = '[id^="seatMap-cabinLayout"]';
const CHARACTERISTICS_BUTTON_SELECTOR = '#seatMap-characteristics button';
const EXPAND_LEGEND_BUTTON_ID = '#seatMap-expandLegendButton';
export const focusFirstAvailableSeat = () => {
  var _document$querySelect;
  (_document$querySelect = document.querySelector('[data-seat-id]:not(:disabled):not([data-selected="true"])')) === null || _document$querySelect === void 0 || _document$querySelect.focus();
};
export const focusSelectedSeat = (row, value) => {
  const seat = document.querySelector(`[data-seat-id="${getSeatId(row, value)}"]`);
  if (seat) {
    seat.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    seat.focus({
      preventScroll: true
    });
    return;
  }
  focusFirstAvailableSeat();
};

/**
 * Focus only, without the scrolling the browser does by default. Where the traveler list
 * should sit is decided by `useScrollActiveTravelerIntoView`, and letting focus scroll as
 * well drags the list back to whichever card happens to be focused.
 */
export const focusOnActiveSeatMapTravelerButton = id => {
  const isNumber = typeof id === 'number' && !Number.isNaN(id);
  if (!isNumber) {
    return;
  }
  const selectors = [TRAVELER_BUTTON_ID(id), TRAVELER_LIST_BUTTON_ID(id)];
  const button = selectors.map(selector => document.querySelector(selector)).find(Boolean);
  button === null || button === void 0 || button.focus({
    preventScroll: true
  });
};
export const focusOnNextSegmentButton = () => {
  var _document$querySelect2;
  (_document$querySelect2 = document.querySelector(SAVE_AND_CONTINUE_BUTTON_ID)) === null || _document$querySelect2 === void 0 || _document$querySelect2.focus();
};
export const isCabinLayoutShown = () => Boolean(document.querySelector(CABIN_LAYOUT_SELECTOR));
export const focusOnFirstCharacteristicButton = () => {
  const selectors = [CHARACTERISTICS_BUTTON_SELECTOR, EXPAND_LEGEND_BUTTON_ID];
  const button = selectors.map(selector => document.querySelector(selector)).find(Boolean);
  button === null || button === void 0 || button.focus();
};
//# sourceMappingURL=focusUtils.js.map